import { Button } from "@heroui/react";
import { LuFilter, LuChevronDown, LuChevronUp } from "react-icons/lu";

/**
 * FilterButton - Reusable filter toggle button with badge
 *
 * @param {boolean} isOpen - Whether filter panel is open
 * @param {Function} onToggle - Toggle callback
 * @param {number} activeCount - Number of active filters (shows badge if > 0)
 */
const FilterButton = ({ isOpen, onToggle, activeCount = 0 }) => {
    return (
        <Button
            variant={activeCount > 0 ? "flat" : "light"}
            color={activeCount > 0 ? "primary" : "default"}
            startContent={<LuFilter size={16} />}
            endContent={
                isOpen ? <LuChevronUp size={16} /> : <LuChevronDown size={16} />
            }
            size="sm"
            onPress={onToggle}
        >
            Filter
            {activeCount > 0 && (
                <span className="bg-primary text-primary-foreground ml-1 rounded-full px-1.5 text-xs">
                    {activeCount}
                </span>
            )}
        </Button>
    );
};

export default FilterButton;
